import React,{useEffect, useState} from "react";
import Tab from "olive-react-myoneui/lib/Tab";
import CourseBundleDescription from "./CourseBundleDescription";
import ReviewsAndRatings from "./ReviewAndRatings";
import axios from "axios";
import { Card, Col, Row } from "olive-react-myoneui";


function CourseOverview({coursedetails}) {
 // const obj = JSON.parse(coursedetails?.course.cb_requirements,"res");
  const [review,setReview] = useState("");

  console.log(coursedetails.course.id,"coursedetails")
  let requirements  = coursedetails?.course.cb_requirements
  let whatUGet  = coursedetails?.course.cb_what_u_get
  requirements = requirements ? JSON.parse(requirements) : ""
  whatUGet = whatUGet ? JSON.parse(whatUGet) : ""

  let evidenceFields = coursedetails.course.cb_evidence_fields ? JSON.parse(coursedetails.course.cb_evidence_fields):[];
  let evFields = '';
  for (const key in evidenceFields)
  {
    evFields += evidenceFields[key]["f_label"]+" , ";
  }
  evFields = evFields.replace(/,\s*$/, "");


  return (
    <Tab.Pane eventKey="overview">
      <div className="tab-course-contents curriculum course-inner-bundle-overview px-0 pt-0 pb-4">
      {coursedetails?.course.cb_evidence_status &&
          coursedetails.course.cb_evidence_status == "1" && (
            <Row>
              <Col>
                <Card
                  className={`
              mk-evidence-info-wrapper bg-transparent mb-3`}
                >
                  <Card.Body className="">
                    <div className="mk-evidence-title">
                      <h1 className="mk-evidence-heading">
                        {coursedetails.course.cb_evidence_label ||
                          "Evidence label"}
                      </h1>
                      <p className="mk-evidence-desc mb-0">
                        {coursedetails.course.cb_evidence_description ||
                          "Evidence description"}{" "}
                        <strong>
                          {evFields}
                        </strong>
                      </p>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          )}
        <CourseBundleDescription className="mt-2 mb-4" courseBundleDescTitle="Description" courseBundleDesc={coursedetails?.course.cb_description} requirements={requirements} whatUGet={whatUGet}/>
        {/* {requirements  && <CourseBundleDescription className="mt-2 mb-4" courseBundleDescTitle="Requirements" courseBundleDesc={requirements}/>} */}
        {coursedetails?.course.course_reviews.reviews.length > 0 && coursedetails?.course?.cb_has_rating == "1" &&
          <ReviewsAndRatings coursedetails = {coursedetails}/>
          }
      </div>
    </Tab.Pane>
  );
}

export default CourseOverview;
